import { lazy } from 'react';
import {  Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/routes/common/ProtectedRoute';
import { SuspenseWrapper } from '@/routes/common/SuspenseWrapper';

const ContentList = lazy(() => import('@/pages/content/List'));
const ContentCreate = lazy(() => import('@/pages/content/Create'));

export const contentRoutes: RouteObject = {
  path: 'content',
  children: [
    {
      index: true,
      element: <Navigate to="list" replace />,
    },
    {
      path: 'list',
      element: (
        <ProtectedRoute pageKey="page:content:list">
          <SuspenseWrapper>
            <ContentList />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
    {
      path: 'create',
      element: (
        <SuspenseWrapper>
          <ContentCreate />
        </SuspenseWrapper>
      ),
    },
  ],
};
